<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
	@import './static/css/reset.css';
	/*reset.css*/
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
    a {
        text-decoration: none;
    }
    .ivu-upload-drag {
        max-height: 200px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue